import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {Employee} from 'main/stores/employees';

class NmbrEmployee extends DomainObject {
  errorsFromLastSync = {};
  employee;

  _relations = {
    employee: Employee
  };

  constructor(other) {
    super();

    makeObservable(this, {
      errorsFromLastSync: observable,
      employee: observable
    });

    this.merge(other);
  }
}

export default NmbrEmployee;
